// import { Observable } from "rxjs";
import is from "@core/comparators/is";
import { blob } from "../blob";

export namespace image {

    //   export function createImage(url: string): Observable<HTMLImageElement>;
    //   export function createImage(file: File): Observable<HTMLImageElement>;
    //   export function createImage(fileOrUrl: File | string): Observable<HTMLImageElement> {
    //       return new Observable<HTMLImageElement>((observer) => {
    //           let fileUrl: string;

    //           if (typeof fileOrUrl == "string") {
    //               fileUrl = fileOrUrl;
    //           } else {
    //               fileUrl = blob.createObjectURL(fileOrUrl);
    //           }

    //           let img = new Image();

    //           img.onload = (a) => {
    //               observer.next(img);
    //               observer.complete();
    //           }

    //           img.onerror = () => {
    //               observer.next(img);
    //               observer.complete();
    //           }

    //           img.src = fileUrl;
    //       });
    //   }

    /**
     * @param imgFile
     * @description  图片文件压缩 处理
     * TODO - 目前没有实现，后期完善
     */
    //   export function imgCompression(imgFile: File | HTMLImageElement): Observable<HTMLImageElement> {
    //       return new Observable<HTMLImageElement>((observer) => {
    //           if (imgFile instanceof File) {
    //               console.log('Received a File');
    //               fileConvertImage(imgFile).subscribe((image) => {
    //                   observer.next(image);
    //                   observer.complete();
    //               }, (error) => {
    //                   observer.next(error);
    //                   observer.complete();
    //               });
    //           } else if (imgFile instanceof HTMLImageElement) {
    //               setTimeout(() => {
    //                   observer.next(imgFile);
    //                   observer.complete();
    //               });
    //           } else {
    //               observer.complete();
    //           }
    //       });
    //   }

    /**
     * 参考资料:
     * LINK - https://en.wikipedia.org/wiki/Magic_number_%28programming%29#In_files
     * LINK - https://en.wikipedia.org/wiki/List_of_file_signatures
     * [ "png", "jpeg", "jpg", "bmp", "gif", "tiff", "tif", "psd", "pdf", "svg", pcf ]
     * @param bytes
     * @description  通过 文件头 获取文件类型
     */
    export function getMimeType(content: ArrayBuffer): string {
        var arr = (new Uint8Array(content)).subarray(0, 12);
        var bytes: string[] = [];
        for (var i = 0; i < arr.length; i++) {
            let code = "0" + arr[i].toString(16);

            code = code.substring(code.length - 2, code.length);

            bytes.push(code);
        }

        let configs = [{
            type: "image/png",
            code: ["89", "50", "4E", "47", "0D", "0A", "1A", "0A"]
        },
        {
            type: "image/jpeg",
            code: ["FF", "D8", "FF", "E0"]
        }, {
            type: "image/jpg",
            code: ["FF", "D8"]
            // codes: [
            //     ["FF", "D8", "FF", "DB"],
            //     ["FF", "D8", "FF", "E0", "00", "10", "4A", "46", "49", "46", "00", "01"],
            //     ["FF", "D8", "FF", "EE"],
            //     ["FF", "D8", "FF", "E1", "*", "*", "45", "78", "69", "66", "00", "00"]
            // ]
        }, {
            type: "image/bmp",
            code: ["42", "4D"]
        }, {
            type: "image/gif",
            codes: [
                ["47", "49", "46", "38", "37", "61"],
                ["47", "49", "46", "38", "39", "61"]
            ]
        }, {
            type: "image/tif",
            code: ["49", "49", "2A", "00"]
        }, {
            type: "image/tiff",
            code: ["4D", "4D", "00", "2A"]
        }, {
            type: "application/x-photoshop",
            code: ["38", "42", "50", "53"]
        }, {
            type: "application/pdf",
            code: ["25", "50", "44", "46", "2D"]
        }, {
            type: "application/xml",
            code: ["3C", "3F", "78", "6D", "6C", "20"]
        }];

        if (bytes.length > 0) {
            for (let i = 0; i < configs.length; i++) {
                let config = configs[i];

                if (config.code) {
                    if (mimeComparator(bytes, config.code)) {
                        if (config.type == "application/xml") {
                            const decoder = new TextDecoder();
                            const textContent = decoder.decode(content);
                            // 匹配svg文件  nosonar - 禁用下一行的 SonarQube 检查
                            const svgPattern = /\<(svg)+[\s\S]*\>[\s\S]*\<\/(svg)\>/; // nosonar
                            if (svgPattern.test(textContent)) {
                                return "image/svg+xml";
                            }
                            else {
                                return "unhandle MIME type, " + bytes.join(" ");
                            }
                        }

                        return config.type;
                    }
                } else if (config.codes) {
                    for (let j = 0; j < config.codes.length; j++) {
                        const code = config.codes[j];

                        if (mimeComparator(bytes, code)) {
                            return config.type;
                        }
                    }
                }
            }
        }

        return "unhandle MIME type, " + bytes.join(" ");
    }

    export function mimeComparator(bytes: string[], codes: string[]) {
        let result = true;
        for (let i = 0; i < codes.length; i++) {
            if (codes[i] != "*" && codes[i].toLowerCase() != bytes[i].toLowerCase()) {
                console.log(bytes.join(" "));
                result = false;
                break;
            }
        }
        return result;
    }

    /**
     * @param imgFile
     * @description 将 file 图片文件转换为 image 元素
     */
    //   function fileConvertImage(imgFile: File): Observable<HTMLImageElement> {
    //       return new Observable<HTMLImageElement>((observer) => {
    //           if (!imgFile) {
    //               let img = new Image();
    //               img.src = window.URL.createObjectURL(imgFile);
    //               img.onload = () => {
    //                   observer.next(img);
    //                   observer.complete();
    //               }
    //               img.onerror = (error) => {
    //                   observer.next();
    //                   observer.complete();
    //               }
    //           }
    //       });
    //   }

}
